/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Autocomplete, TextField } from '@mui/material';
import React, { forwardRef } from 'react';
import { UIAutocompleteProps } from './types';

const Comp = <
  T,
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
  FreeSolo extends boolean = false
>(
  props: UIAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
  ref: React.ForwardedRef<Record<string, never>>
) => {
  const { TextFieldProps, getOptionLabel, ...rest } = props;
  return (
    <Autocomplete
      {...rest}
      renderInput={(params) => <TextField {...params} {...TextFieldProps} />}
      //@ts-ignore
      getOptionLabel={getOptionLabel}
      ref={ref}
      sx={{
        '& .MuiInputBase-root': {
          backgroundColor: rest.disabled ? '#f3f3f3' : 'inherit',
        },
        ...rest.sx,
      }}
    />
  );
};

const UIAutocomplete = forwardRef(Comp) as <
  T,
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
  FreeSolo extends boolean = false
>(
  props: UIAutocompleteProps<T, Multiple, DisableClearable, FreeSolo> & {
    ref?: React.ForwardedRef<Record<string, never>>;
  }
) => React.ReactElement<UIAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>>;

export default UIAutocomplete;
